export default __webpack_public_path__ + "static/media/logo.da6eb0ac.jpeg";